"use client";

import React, { useState } from "react";
import { Logo } from "@/design-elements/logo";
import { LandingHero } from "./LandingHero";
import { LandingToggle } from "./LandingToggle";
import { SavingsCalculator } from "./SavingsCalculator";
import { PopularProducts } from "./PopularProducts";
import { useLandingData } from "./useLandingData";
import type { LandingTabId } from "./types";

interface LandingPanelProps {
	showMobileLogo?: boolean;
	className?: string;
}

export const LandingPanel: React.FC<LandingPanelProps> = ({
	showMobileLogo = false,
	className = "",
}) => {
	const { data } = useLandingData();
	const [activeTabId, setActiveTabId] = useState<LandingTabId>("devices");

	if (!data) {
		return (
			<div className="w-full h-full flex items-center justify-center">
				<div className="w-full max-w-md space-y-4 p-6">
					<div className="h-8 bg-[var(--automint-onboarding-listbox-hover-light)] rounded animate-pulse" />
					<div className="h-40 bg-[var(--automint-onboarding-listbox-hover-light)] rounded-2xl animate-pulse" />
					<div className="h-24 bg-[var(--automint-onboarding-listbox-hover-light)] rounded-2xl animate-pulse" />
				</div>
			</div>
		);
	}

	const activeTab = data.calculator.tabs[activeTabId];

	return (
		<div
			className={`w-full min-h-full flex flex-col items-center justify-center gap-[16px] min-[1500px]:py-[20px] min-[1500px]:gap-[22px] ${className}`}
		>
			{showMobileLogo && (
				<div className="md:hidden">
					<Logo
						showText={true}
						invert
						size={36}
						className="[&_span]:!text-[var(--automint-black)] [&_span]:!text-xl [&_span]:!font-medium"
					/>
				</div>
			)}

			<LandingHero data={data.hero} />

			<LandingToggle
				data={data.toggle}
				value={activeTabId}
				onChange={setActiveTabId}
			/>

			<SavingsCalculator data={data.calculator} activeTab={activeTab} />

			<PopularProducts data={data.popular} />
		</div>
	);
};
